export const aboutYouMailConfig = {
    van: true,
    car: true,
    home: true,
    device: false,
    travel: false
}